const mod = require('../bahabot.module.js')

function bahabotEventSourceFactory($timeout) {
    class _SSEConnection {
        constructor(url, raw = false) {
            this.raw = raw
            this.url = url
            this.source = new EventSource(url);
            this.listeners = new Map();
        }

        on(eventName, callback) {
            if (!this.listeners.has(eventName)) {
                this.listeners.set(eventName, new Set());

                this.source.addEventListener(eventName, (event) => {
                    const data = event.data
                        ? (this.raw ? event.data : JSON.parse(event.data))
                        : null;
                    $timeout(() => {
                        for (const cb of this.listeners.get(eventName)) {
                            cb(data, event);
                        }
                    })
                })
            }

            this.listeners.get(eventName).add(callback);

            return () => {
                this.listeners.get(eventName).delete(callback);
            }
        }

        close() {
            this.source.close();
            this.listeners.clear();
        }
    }

    this.connect = function(url, raw = false) {
        return new _SSEConnection(url, raw);
    }
}

mod.service('EventSourceService', ["$timeout", bahabotEventSourceFactory]);
